import currency from "currency.js";
import moment from "moment";

const formatCurrency = (cents, precision = 2) => {
  const decimals = parseInt(cents, 10) / 100;
  return currency(isNaN(decimals) ? 0 : decimals, {
    symbol: "$",
    separator: ",",
    decimal: ".",
    precision: precision,
  }).format();
};

const formatPercentage = (value) => {
  return `${parseInt(value, 10)}%`;
};

const formatDate = (strDate) => moment(strDate).format("L");
const formatDateMonth = (strDate) => moment(strDate).format("MMM YYYY");
const formatDateMonthShort = (strDate) => moment(strDate).format("MMM YY");

export {
  formatCurrency,
  formatPercentage,
  formatDate,
  formatDateMonth,
  formatDateMonthShort,
};
